import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import AddEducation from "../components/AddEducation";

export default class Education extends Component {
  render() {
    const { onCancelClick, setToaster } = this.props;
    return (
      <div>
        <Switch>
          <Route
            exact
            path="/people/employees/dashboard/:EmployeeId/resume/7/setup"
            render={() => (
              <AddEducation
                {...this.props}
                onCancelClick={onCancelClick}
                editMode={false}
                setToaster={setToaster}
              />
            )}
          />
          <Route
            path="/people/employees/dashboard/:EmployeeId/resume/7/:EducationId"
            render={() => (
              <AddEducation
                {...this.props}
                onCancelClick={onCancelClick}
                editMode={true}
                setToaster={setToaster}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}
